import(/* webpackMode: "eager" */ "/app/app/events-and-offers/[slug]/page.js");
